module.exports = __webpack_public_path__ + "img/car-type.2339d880.svg";